/*!
 * FiiLiT — Molécules Olfactives | fh-molecules.js
 * 5 styles · 3 bases de données (matières, molécules naturelles poétiques,
 * molécules aromatiques INCI) · textes éditables dans le bloc (traduisibles)
 * · vitesse · luminosité · transition
 */
(function (W) {
'use strict';

// ── Palettes ────────────────────────────────────────────────
const PAL = {
  teal:    { a:[0,115,119],   b:[64,193,187],  c:[200,149,110], d:[248,244,239] },
  ambre:   { a:[200,149,110], b:[232,190,130], c:[0,115,119],   d:[248,244,239] },
  iris:    { a:[107,74,158],  b:[155,125,212], c:[64,193,187],  d:[220,210,240] },
  rose:    { a:[200,75,138],  b:[232,123,183], c:[248,210,80],  d:[255,235,245] },
  or:      { a:[184,150,10],  b:[232,200,70],  c:[64,193,187],  d:[255,245,200] },
  blanc:   { a:[120,180,180], b:[160,210,205], c:[200,149,110], d:[240,235,230] },
};

// ── Vraies matières premières FiiLiT (16 parfums) ──────────
// Source : INCI + sourcing éthique + 07_Matieres_Premieres.md
const MOLS = [
  // ─ Hespéridées
  { sym:'Ber', name:'Bergamote',        src:'Calabre, Italie',         fam:'Hespéridée',   parfum:'Amante · Tumbao · Irida',            rgb:[200,235,100] },
  { sym:'Nér', name:'Néroli',           src:"Fleur d'oranger · Tunisie",fam:'Florale-Hespéridée', parfum:'Irida · Mazhar · Surya',      rgb:[255,215,95]  },
  { sym:'Mand',name:'Mandarine',        src:'Sicile, Italie',          fam:'Hespéridée',   parfum:'Rose Désir · La Perla Maya',         rgb:[255,160,40]  },
  { sym:'Yuz', name:'Yuzu',             src:'Japon',                   fam:'Hespéridée',   parfum:'Kadō Japon',                         rgb:[230,225,60]  },
  { sym:'Big', name:'Bigarade',         src:'Fleur d\'oranger amer',   fam:'Hespéridée',   parfum:'Irida · Mazhar · Tehani',            rgb:[250,195,60]  },
  { sym:'Pet', name:'Petitgrain',       src:'Feuilles de bigaradier',  fam:'Aromatique',   parfum:'Amante · Irida',                     rgb:[180,220,80]  },
  // ─ Florales
  { sym:'Ros', name:'Rose de Damas',    src:'Bulgarie · Maroc',        fam:'Florale Rosée',parfum:'Rose Désir Damas',                   rgb:[240,90,150]  },
  { sym:'Jas', name:'Jasmin',           src:'Égypte · Grasse',         fam:'Florale',      parfum:'Kadō Japon',                         rgb:[245,245,200] },
  { sym:'Tia', name:'Tiaré',            src:'Polynésie française',     fam:'Florale',      parfum:'Tehani Polynésie',                   rgb:[255,240,210] },
  { sym:'Ylg', name:'Ylang-Ylang',      src:'Comores · Madagascar',    fam:'Florale-Épicée',parfum:'Surya Bali · Kadō',                 rgb:[255,205,80]  },
  { sym:'Tub', name:'Tubéreuse',        src:'Inde · Mexique',          fam:'Florale Absolue',parfum:'La Perla Maya',                    rgb:[255,230,240] },
  { sym:'Fra', name:'Frangipanier',     src:'Bali · Indonésie',        fam:'Florale',      parfum:'Surya Bali',                         rgb:[255,220,180] },
  { sym:'Sak', name:'Fleur de Cerisier',src:'Japon',                   fam:'Florale Poudrée',parfum:'Kadō Japon',                       rgb:[255,192,203] },
  // ─ Boisées & Résines
  { sym:'San', name:'Santal',           src:'Australie (Fair Trade)',  fam:'Boisée Crémeuse',parfum:'Le Temps des Songes',              rgb:[195,145,90]  },
  { sym:'Oud', name:'Oud',              src:'Asie du Sud-Est',         fam:'Boisée Profonde',parfum:'Mushussu Babylonia',               rgb:[120,60,30]   },
  { sym:'Vét', name:'Vétiver',          src:'Haïti (Fair Trade)',      fam:'Boisée Terrée', parfum:'Tumbao Cuba · Amante',             rgb:[100,130,60]  },
  { sym:'Pat', name:'Patchouli',        src:'Bali · Indonésie',        fam:'Boisée Terrée', parfum:'Patchilaï India · Surya Bali',     rgb:[140,100,50]  },
  { sym:'Enc', name:'Encens (Oliban)',  src:'Oman · Somalie',          fam:'Résineuse',     parfum:'Tumbao · Kadō · Mushussu',         rgb:[220,180,100] },
  { sym:'Lab', name:'Labdanum',         src:'Crète · Ciste',           fam:'Résineuse Ambrée',parfum:'Mushussu Babylonia',             rgb:[180,120,60]  },
  { sym:'Ben', name:'Benjoin',          src:'Laos · Styrax',           fam:'Balsamique',    parfum:'Mazhar Atlas · Patchilaï',         rgb:[200,155,90]  },
  { sym:'Mou', name:'Mousse de Chêne', src:'Balkans · Lichen',        fam:'Chypré',        parfum:'Ice Boréal',                        rgb:[80,140,80]   },
  { sym:'Amy', name:'Amyris',           src:'Haïti',                   fam:'Boisée Douce',  parfum:'Le Temps des Songes',              rgb:[210,180,130] },
  // ─ Orientales & Épicées
  { sym:'Van', name:'Fève Tonka',       src:'Venezuela · Brésil',      fam:'Gourmande',     parfum:'Joli Coeur · Tehani · Mazhar',     rgb:[225,165,85]  },
  { sym:'Car', name:'Cardamome',        src:'Guatemala · Inde',        fam:'Épicée Fraîche',parfum:'Tumbao Cuba',                       rgb:[160,200,130] },
  { sym:'Poi', name:'Poivre noir',      src:'Inde · Madagascar',       fam:'Épicée',        parfum:'Ice Boréal · Surya',               rgb:[80,80,100]   },
  { sym:'Gin', name:'Gingembre',        src:'Jamaïque · Inde',         fam:'Épicée Fraîche',parfum:'Mazhar Atlas',                     rgb:[220,160,70]  },
  { sym:'Gin', name:'Girofle',          src:'Madagascar · Zanzibar',   fam:'Épicée Chaude', parfum:'Patchilaï India',                  rgb:[180,80,40]   },
  { sym:'Mus', name:'Noix de Muscade',  src:'Indonésie · Grenade',     fam:'Épicée',        parfum:'Rose Désir · Mushussu',            rgb:[200,140,60]  },
  // ─ Aromatiques & Aquatiques
  { sym:'Euc', name:'Eucalyptus',       src:'Australie · Espagne',     fam:'Aromatique',    parfum:'Ice Boréal · Tumbao',              rgb:[100,200,180] },
  { sym:'Géra',name:'Géranium',         src:'Égypte · Bourbon',        fam:'Florale Verte', parfum:'Ice Boréal · Rose Désir',          rgb:[160,220,120] },
  { sym:'Rom', name:'Romarin',          src:'Provence · Espagne',      fam:'Aromatique',    parfum:'Kadō Japon',                       rgb:[120,180,100] },
  { sym:'Cèd', name:'Cèdre de l\'Atlas',src:'Maroc',                   fam:'Boisée',        parfum:'Mazhar Atlas',                     rgb:[165,120,70]  },
  { sym:'Cyp', name:'Cyprès',           src:'Méditerranée',            fam:'Boisée Fraîche',parfum:'Le Temps des Songes',              rgb:[80,150,100]  },
  // ─ Exotiques & Rares
  { sym:'Prp', name:'Priprioca',        src:'Amazonie · Brésil',       fam:'Terrée Unique', parfum:'Saudade Amazonia',                 rgb:[130,90,160]  },
  { sym:'Tia', name:'Iris',             src:'Florence · Maroc',        fam:'Poudrée',       parfum:'Irida Cyclades',                   rgb:[170,140,220] },
  { sym:'Éle', name:'Élémi',            src:'Philippines',             fam:'Résineuse',     parfum:'Tumbao · Surya',                   rgb:[190,220,150] },
];

// ══════════════════════════════════════════════════════════
// DATASET 2 — Molécules naturelles (noms poétiques des parfumeurs)
// Zéro terme chimique effrayant. Muscs propres uniquement (Ambrette,
// macrocyclique biodégradable) — Galaxolide/HHCB et Tonalide/AHTN exclus.
// ══════════════════════════════════════════════════════════
const NATURELLES = [
  {"sym": "Lin", "name": "Linalol", "src": "Lavande · Bergamote · Néroli", "fam": "Florale-Boisée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Surya · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [170, 120, 220]},
  {"sym": "Gér", "name": "Géraniol", "src": "Rose · Géranium · Citron", "fam": "Rosée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [240, 90, 150]},
  {"sym": "Lim", "name": "Limonène", "src": "Citron · Pamplemousse · Bergamote", "fam": "Hespéridée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [255, 205, 55]},
  {"sym": "Eug", "name": "Eugénol", "src": "Girofle · Ylang-Ylang · Patchouli", "fam": "Épicée", "parfum": "Tehani · Mushussu · Patchilaï · Rose Désir · La Perla Maya", "rgb": [195, 115, 55]},
  {"sym": "Ion", "name": "Ionone α", "src": "Iris · Violette", "fam": "Poudrée", "parfum": "Irida · Mazhar · Le Temps des Songes", "rgb": [130, 85, 210]},
  {"sym": "Van", "name": "Vanilline", "src": "Vanille · Fève Tonka", "fam": "Gourmande", "parfum": "", "rgb": [225, 165, 85], "note": "Correspondance parfum à valider avec les INCI FiiLiT"},
  {"sym": "Nér", "name": "Néroli", "src": "Fleur d'Oranger · Tunisie", "fam": "Florale", "parfum": "Amante · Irida · Mazhar", "rgb": [255, 215, 95]},
  {"sym": "Far", "name": "Farnésol", "src": "Muguet · Rose · Santal · Ylang", "fam": "Florale", "parfum": "Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Le Temps des Songes · La Perla Maya", "rgb": [95, 205, 135]},
  {"sym": "Cin", "name": "Cinéole", "src": "Eucalyptus · Romarin", "fam": "Aromatique", "parfum": "Ice Boréal · Tumbao · Kadō", "rgb": [55, 185, 175]},
  {"sym": "Cit", "name": "Citral", "src": "Verveine · Citronnelle · Bergamote", "fam": "Hespéridée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [235, 225, 55]},
  {"sym": "Jas", "name": "Benzyl Acétate", "src": "Jasmin · Ylang-Ylang", "fam": "Florale", "parfum": "Kadō · Surya · Tehani", "rgb": [245, 245, 210]},
  {"sym": "Ros", "name": "Oxyde de Rose", "src": "Rose bulgare", "fam": "Rosée", "parfum": "Rose Désir Damas", "rgb": [255, 145, 165]},
  {"sym": "San", "name": "α-Santalol", "src": "Bois de Santal · Australie", "fam": "Boisée", "parfum": "Le Temps des Songes · Tehani", "rgb": [195, 145, 90]},
  {"sym": "Amb", "name": "Ambroxide", "src": "Ambre · Ciste", "fam": "Ambrée", "parfum": "Mushussu Babylonia", "rgb": [210, 168, 108]},
  {"sym": "Oud", "name": "Ar-Tumérone", "src": "Oud · Bois précieux", "fam": "Boisée", "parfum": "Mushussu Babylonia", "rgb": [135, 72, 42]},
  {"sym": "Ber", "name": "Bergaptène", "src": "Bergamote · Citrus", "fam": "Hespéridée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Mazhar", "rgb": [205, 235, 100]},
  {"sym": "Msc", "name": "Muscone", "src": "Graine d'Ambrette · musc naturel macrocyclique", "fam": "Musquée", "parfum": "", "rgb": [235, 225, 215], "note": "Non utilisé actuellement · alternative propre aux muscs polycycliques polluants (Galaxolide, Tonalide)"},
  {"sym": "Cou", "name": "Coumarine", "src": "Fève Tonka · Foin coupé", "fam": "Gourmande", "parfum": "Joli Cœur · Mazhar · Tehani · Mushussu · Surya · Patchilaï", "rgb": [225, 165, 85]},
  {"sym": "Cnl", "name": "Citronellol", "src": "Géranium · Bigarade · Rose", "fam": "Rosée", "parfum": "Irida · Ice Boréal · Kadō · Mazhar · Rose Désir · Le Temps des Songes", "rgb": [255, 145, 165]},
  {"sym": "IEg", "name": "Isoeugénol", "src": "Vétiver · Ylang · Labdanum", "fam": "Épicée Chaude", "parfum": "Kadō · Tehani · Mushussu · Le Temps des Songes · La Perla Maya", "rgb": [180, 80, 40]},
  {"sym": "BzB", "name": "Benzoate de Benzyle", "src": "Benjoin · Ylang", "fam": "Balsamique", "parfum": "Tumbao · Irida · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · La Perla Maya", "rgb": [200, 155, 90]},
  {"sym": "BzA", "name": "Alcool Benzylique", "src": "Ylang-Ylang · Jasmin", "fam": "Florale", "parfum": "Irida · Kadō · Mazhar · Le Temps des Songes", "rgb": [245, 245, 210]},
  {"sym": "BzS", "name": "Salicylate de Benzyle", "src": "Ylang-Ylang", "fam": "Florale Douce", "parfum": "Kadō · Tehani · Patchilaï · La Perla Maya", "rgb": [255, 220, 180]},
  {"sym": "Hyd", "name": "Hydroxycitronnellal", "src": "Muguet", "fam": "Florale Fraîche", "parfum": "Mushussu Babylonia", "rgb": [95, 205, 180]}
];

// ══════════════════════════════════════════════════════════
// DATASET 3 — Molécules aromatiques INCI (chimie, formules)
// Cross-référencées avec les INCI réels des 16 parfums FiiLiT.
// Ces 2 tableaux ne sont que des filets de sécurité : les textes affichés
// viennent des champs text_naturelles / text_molecules du bloc (traduisibles).
// ══════════════════════════════════════════════════════════
const MOLECULES = [
  {"sym": "Lim", "name": "Limonène", "sci": "C₁₀H₁₆", "src": "Bergamote, agrumes, encens", "fam": "Hespéridée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [255, 205, 55]},
  {"sym": "Lin", "name": "Linalol", "sci": "C₁₀H₁₈O", "src": "Bergamote, néroli, lavande", "fam": "Florale-Boisée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Surya · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [170, 120, 220]},
  {"sym": "Gér", "name": "Géraniol", "sci": "C₁₀H₁₈O", "src": "Géranium, citron, cardamome", "fam": "Rosée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [240, 90, 150]},
  {"sym": "Cit", "name": "Citral", "sci": "C₁₀H₁₆O", "src": "Bergamote, citron, gingembre", "fam": "Hespéridée", "parfum": "Amante · Tumbao · Irida · Ice Boréal · Kadō · Mazhar · Tehani · Mushussu · Rose Désir · Le Temps des Songes · La Perla Maya", "rgb": [235, 225, 55]},
  {"sym": "Cnl", "name": "Citronellol", "sci": "C₁₀H₂₀O", "src": "Géranium, bigarade", "fam": "Rosée", "parfum": "Irida · Ice Boréal · Kadō · Mazhar · Rose Désir · Le Temps des Songes", "rgb": [255, 145, 165]},
  {"sym": "BzB", "name": "Benzoate de Benzyle", "sci": "C₁₄H₁₂O₂", "src": "Benjoin, baume du tolu, ylang", "fam": "Balsamique", "parfum": "Tumbao · Irida · Kadō · Mazhar · Tehani · Mushussu · Patchilaï · La Perla Maya", "rgb": [200, 155, 90]},
  {"sym": "BzA", "name": "Alcool Benzylique", "sci": "C₇H₈O", "src": "Ylang-Ylang, jasmin", "fam": "Florale", "parfum": "Irida · Kadō · Mazhar · Le Temps des Songes", "rgb": [245, 245, 210]},
  {"sym": "BzS", "name": "Salicylate de Benzyle", "sci": "C₁₄H₁₂O₃", "src": "Ylang-Ylang", "fam": "Florale Douce", "parfum": "Kadō · Tehani · Patchilaï · La Perla Maya", "rgb": [255, 220, 180]},
  {"sym": "Far", "name": "Farnésol", "sci": "C₁₅H₂₆O", "src": "Santal, ylang, amyris, jasmin", "fam": "Florale", "parfum": "Kadō · Mazhar · Tehani · Mushussu · Patchilaï · Le Temps des Songes · La Perla Maya", "rgb": [95, 205, 135]},
  {"sym": "Cou", "name": "Coumarine", "sci": "C₉H₆O₂", "src": "Fève Tonka", "fam": "Gourmande", "parfum": "Joli Cœur · Mazhar · Tehani · Mushussu · Surya · Patchilaï", "rgb": [225, 165, 85]},
  {"sym": "Eug", "name": "Eugénol", "sci": "C₁₀H₁₂O₂", "src": "Girofle, patchouli, benjoin", "fam": "Épicée", "parfum": "Tehani · Mushussu · Patchilaï · Rose Désir · La Perla Maya", "rgb": [195, 115, 55]},
  {"sym": "IEg", "name": "Isoeugénol", "sci": "C₁₀H₁₂O₂", "src": "Vétiver, ylang, labdanum, muscade", "fam": "Épicée Chaude", "parfum": "Kadō · Tehani · Mushussu · Le Temps des Songes · La Perla Maya", "rgb": [180, 80, 40]},
  {"sym": "Ion", "name": "Alpha-Isométhyl Ionone", "sci": "C₁₄H₂₂O", "src": "Iris (note poudrée)", "fam": "Poudrée", "parfum": "Irida · Mazhar · Le Temps des Songes", "rgb": [130, 85, 210]},
  {"sym": "Hyd", "name": "Hydroxycitronnellal", "sci": "C₁₀H₂₀O₂", "src": "Muguet (note synthétique)", "fam": "Florale Fraîche", "parfum": "Mushussu Babylonia", "rgb": [95, 205, 180]},
  {"sym": "AmC", "name": "Amyl Cinnamal", "sci": "C₁₄H₁₈O", "src": "Jasmin (note synthétique)", "fam": "Florale", "parfum": "Mazhar Atlas", "rgb": [255, 235, 200]},
  {"sym": "HxC", "name": "Hexyl Cinnamal", "sci": "C₁₅H₂₀O", "src": "Camomille (note synthétique)", "fam": "Florale Fruitée", "parfum": "Tumbao Cuba", "rgb": [255, 200, 140]},
  {"sym": "HCA", "name": "Alpha-Hexyl Cinnamaldéhyde", "sci": "C₁₅H₂₀O", "src": "Jasmin (note synthétique)", "fam": "Florale", "parfum": "Surya Bali", "rgb": [245, 245, 180]},
  {"sym": "Cin2", "name": "Cinnamal", "sci": "C₉H₈O", "src": "Cannelle, patchouli (trace)", "fam": "Épicée Chaude", "parfum": "Patchilaï India", "rgb": [190, 90, 50]},
  {"sym": "Msc", "name": "Muscone (Ambrette)", "sci": "C₁₆H₃₀O", "src": "Graine d'Ambrette — musc naturel macrocyclique, biodégradable", "fam": "Musquée", "parfum": "", "rgb": [235, 225, 215], "note": "Non utilisé actuellement · alternative propre aux muscs polycycliques polluants (Galaxolide/HHCB, Tonalide/AHTN exclus)"}
];

// ── Utilitaires ──────────────────────────────────────────────
const rnd  = (a,b) => a + Math.random()*(b-a);
const clmp = (v,a,b) => Math.max(a,Math.min(b,v));
const d2   = (ax,ay,bx,by) => (ax-bx)**2+(ay-by)**2;
const pick = arr => arr[Math.floor(Math.random()*arr.length)];

function rgba(r,g,b,a=1) {
  return `rgba(${r|0},${g|0},${b|0},${clmp(a,0,1).toFixed(3)})`;
}

function brightRgb(rgb, br) {
  // br = 1 = normal, 2 = double, 0.5 = half
  return [clmp(rgb[0]*br,0,255), clmp(rgb[1]*br,0,255), clmp(rgb[2]*br,0,255)];
}

function glow(ctx,x,y,r,rgb,a) {
  const g=ctx.createRadialGradient(x,y,0,x,y,r);
  g.addColorStop(0, rgba(...rgb,a*.55));
  g.addColorStop(.5,rgba(...rgb,a*.18));
  g.addColorStop(1, rgba(...rgb,0));
  ctx.fillStyle=g;
  ctx.beginPath();ctx.arc(x,y,r,0,Math.PI*2);ctx.fill();
}

function lbl(ctx,text,x,y,rgb,a,sz=9) {
  ctx.save();
  ctx.globalAlpha=clmp(a,0,1);
  ctx.font=`300 ${sz}px 'Urbanist',sans-serif`;
  ctx.fillStyle=rgba(...rgb);
  ctx.textAlign='center';ctx.textBaseline='bottom';
  ctx.fillText(text,x,y);
  ctx.restore();
}

function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

// ── Parser du format « texte pipe » (champs texte du bloc, traduisibles) ──
// Une entrée par ligne : sym | nom | sci | origine | famille | parfums | R,G,B | note
// Les lignes commençant par # sont des commentaires.
function parseMolLines(txt) {
  const out = [];
  if (!txt) return out;
  txt.split(/\r?\n/).forEach(raw => {
    const line = raw.trim();
    if (!line || line.charAt(0) === '#') return;
    const f = line.split('|').map(s => s.trim());
    if (!f[0]) return;
    let rgb = [170,120,220];
    if (f[6]) {
      const p = f[6].replace(/[\[\]]/g, '').split(',').map(n => parseInt(n, 10));
      if (p.length === 3 && p.every(n => Number.isFinite(n))) rgb = p;
    }
    out.push({
      sym: f[0],
      name: f[1] || f[0],
      sci: f[2] || '',
      src: f[3] || '',
      fam: f[4] || '',
      parfum: f[5] || '',
      rgb: rgb,
      note: f[7] || ''
    });
  });
  return out;
}

// Le texte du bloc prime ; le tableau JS n'est qu'un filet de sécurité.
function parseMolText(txt, fallback) {
  if (txt && txt.trim()) {
    const parsed = parseMolLines(txt);
    if (parsed.length >= 3) return parsed;
  }
  return fallback;
}

// ── Sélection de la base + filtrage par ingrédients personnalisés ──
function buildMolSet(datasetKey, ingredientStr, texts) {
  texts = texts || {};
  let pool;
  if      (datasetKey === 'naturelles') pool = parseMolText(texts.nat, NATURELLES);
  else if (datasetKey === 'molecules')  pool = parseMolText(texts.mol, MOLECULES);
  else if (datasetKey === 'tous')       pool = parseMolText(texts.mat, MOLS).concat(parseMolText(texts.mol, MOLECULES));
  else                                  pool = parseMolText(texts.mat, MOLS);

  if (!ingredientStr || !ingredientStr.trim()) return pool;
  const names = ingredientStr.split(/[\n,]+/).map(s=>s.trim().toLowerCase()).filter(Boolean);
  const filtered = pool.filter(m => names.some(n => m.name.toLowerCase().includes(n) || n.includes(m.name.toLowerCase())));
  return filtered.length >= 3 ? filtered : pool;
}

// ════════════════════════════════════════════════════════════
// STYLE 1 — Constellation Olfactive
// ════════════════════════════════════════════════════════════
const Constellation = {
  init(W,H,mols) {
    return { nodes: Array.from({length:58},()=>{
      const m=pick(mols);
      return {x:rnd(20,W-20),y:rnd(20,H-20),vx:(Math.random()-.5)*.35,vy:(Math.random()-.5)*.35,
              r:rnd(1.8,4.8),ph:rnd(0,Math.PI*2),op:.5,mol:m,rgb:[...m.rgb]};
    })};
  },
  update(s,t,mx,my,W,H,spd) {
    const sp=spd*.35;
    s.nodes.forEach(n=>{
      const dx=n.x-mx,dy=n.y-my,d=Math.sqrt(dx*dx+dy*dy);
      if(d<120&&d>0){const f=(120-d)/120*.7;n.vx+=dx/d*f;n.vy+=dy/d*f;}
      n.vx*=.97;n.vy*=.97;n.x+=n.vx*sp;n.y+=n.vy*sp;
      if(n.x<-10)n.x=W+10;if(n.x>W+10)n.x=-10;
      if(n.y<-10)n.y=H+10;if(n.y>H+10)n.y=-10;
      n.op=.28+Math.sin(t*(.0013*spd)+n.ph)*.3;
    });
  },
  draw(ctx,s,t,W,H,p,br,showLbl) {
    const C=160;
    ctx.save();
    for(let i=0;i<s.nodes.length;i++){
      for(let j=i+1;j<s.nodes.length;j++){
        const a=s.nodes[i],b=s.nodes[j];
        const d=Math.sqrt(d2(a.x,a.y,b.x,b.y));
        if(d<C){
          ctx.globalAlpha=(1-d/C)*.28*a.op;
          ctx.strokeStyle=rgba(...brightRgb(a.rgb,br));ctx.lineWidth=.65;
          ctx.beginPath();ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);ctx.stroke();
        }
      }
    }
    ctx.restore();
    s.nodes.forEach(n=>{
      const rgb=brightRgb(n.rgb,br);
      glow(ctx,n.x,n.y,n.r*5.5,rgb,n.op*.55);
      ctx.save();ctx.globalAlpha=Math.min(n.op+.15,1);
      ctx.fillStyle=rgba(...rgb);ctx.beginPath();ctx.arc(n.x,n.y,n.r,0,Math.PI*2);ctx.fill();
      if(showLbl&&n.r>2.5) lbl(ctx,n.mol.sym,n.x,n.y-n.r-2,rgb,n.op*.75,Math.round(n.r*3));
      ctx.restore();
    });
  },
  tip(s,mx,my) {
    let best=null,bD=32;
    s.nodes.forEach(n=>{const d=Math.sqrt(d2(n.x,n.y,mx,my));if(d<bD){bD=d;best=n;}});
    return best?best.mol:null;
  }
};

// ════════════════════════════════════════════════════════════
// STYLE 2 — Floraison Naturelle (courbes pétales de rose)
// ════════════════════════════════════════════════════════════
const Floraison = {
  init(W,H,mols) {
    const S=Math.min(W,H);
    const ctrs=[
      {x:W*.28,y:H*.46,k:5,R:S*.22},
      {x:W*.72,y:H*.42,k:3,R:S*.17},
      {x:W*.50,y:H*.70,k:4,R:S*.14},
      {x:W*.50,y:H*.28,k:6,R:S*.12},
    ];
    const nodes=[];
    mols.forEach((m,i)=>{
      const c=ctrs[i%ctrs.length];
      nodes.push({mol:m,rgb:[...m.rgb],c,th:rnd(0,Math.PI*2),spd:rnd(.0004,.0011),ph:rnd(0,Math.PI*2),op:.5});
    });
    while(nodes.length<48){
      const m=pick(mols),c=pick(ctrs);
      nodes.push({mol:m,rgb:[...m.rgb],c,th:rnd(0,Math.PI*2),spd:rnd(.0003,.001),ph:rnd(0,Math.PI*2),op:.5});
    }
    return{ctrs,nodes};
  },
  _pt(n) {
    const {k,R,x:cx,y:cy}=n.c;
    const r=R*Math.abs(Math.cos(k*n.th));
    return{x:cx+r*Math.cos(n.th),y:cy+r*Math.sin(n.th)};
  },
  update(s,t,mx,my,W,H,spd) {
    s.nodes.forEach(n=>{n.th+=n.spd*spd;n.op=.32+Math.sin(t*(.001*spd)+n.ph)*.28;});
    s.ctrs.forEach((c,i)=>{c.x+=Math.sin(t*.0003+i*1.3)*.1;c.y+=Math.cos(t*.00035+i*.9)*.08;});
  },
  draw(ctx,s,t,W,H,p,br,showLbl) {
    // Petal outlines
    s.ctrs.forEach(c=>{
      ctx.save();ctx.strokeStyle=rgba(...brightRgb(p.a,br),.08);ctx.lineWidth=.8;ctx.beginPath();
      for(let i=0;i<=720;i++){const a=i/720*Math.PI*2,r=c.R*Math.abs(Math.cos(c.k*a));
        const x=c.x+r*Math.cos(a),y=c.y+r*Math.sin(a);i===0?ctx.moveTo(x,y):ctx.lineTo(x,y);}
      ctx.closePath();ctx.stroke();ctx.restore();
    });
    s.nodes.forEach(n=>{
      const pt=this._pt(n);
      const rgb=brightRgb(n.rgb,br);
      glow(ctx,pt.x,pt.y,16,rgb,n.op*.5);
      ctx.save();ctx.globalAlpha=n.op;ctx.fillStyle=rgba(...rgb);
      ctx.beginPath();ctx.arc(pt.x,pt.y,2.8,0,Math.PI*2);ctx.fill();
      if(showLbl) lbl(ctx,n.mol.sym,pt.x,pt.y-6,rgb,n.op*.72,10);
      ctx.restore();
    });
  },
  tip(s,mx,my) {
    let best=null,bD=28;
    s.nodes.forEach(n=>{const pt=this._pt(n);const d=Math.sqrt(d2(pt.x,pt.y,mx,my));if(d<bD){bD=d;best=n;}});
    return best?best.mol:null;
  }
};

// ════════════════════════════════════════════════════════════
// STYLE 3 — Brume Sensorielle
// ════════════════════════════════════════════════════════════
const Brume = {
  init(W,H,mols) {
    const clouds=Array.from({length:14},(_,i)=>({
      x:rnd(0,W),y:rnd(0,H),r:rnd(90,260),
      vx:(Math.random()-.5)*.055,vy:(Math.random()-.5)*.055,
      al:rnd(.04,.085),ph:rnd(0,Math.PI*2),
      rgb:i%3===0?[200,149,110]:i%3===1?[64,193,187]:[155,125,212],
    }));
    const nodes=mols.map(m=>({
      mol:m,rgb:[...m.rgb],x:rnd(0,W),y:rnd(0,H),
      vx:(Math.random()-.5)*.08,vy:(Math.random()-.5)*.08,ph:rnd(0,Math.PI*2),op:.3,
    }));
    while(nodes.length<36){const m=pick(mols);nodes.push({mol:m,rgb:[...m.rgb],x:rnd(0,W),y:rnd(0,H),vx:(Math.random()-.5)*.07,vy:(Math.random()-.5)*.07,ph:rnd(0,Math.PI*2),op:.3});}
    return{clouds,nodes};
  },
  update(s,t,mx,my,W,H,spd) {
    const sp=spd*.6;
    s.clouds.forEach(c=>{
      c.x+=c.vx*sp;c.y+=c.vy*sp;
      if(c.x<-c.r)c.x=W+c.r;if(c.x>W+c.r)c.x=-c.r;
      if(c.y<-c.r)c.y=H+c.r;if(c.y>H+c.r)c.y=-c.r;
      c.curAl=c.al*(.65+Math.sin(t*(.0007*spd)+c.ph)*.35);
    });
    s.nodes.forEach(n=>{
      n.x+=n.vx*sp;n.y+=n.vy*sp;
      if(n.x<-10)n.x=W+10;if(n.x>W+10)n.x=-10;
      if(n.y<-10)n.y=H+10;if(n.y>H+10)n.y=-10;
      n.op=.18+Math.sin(t*(.0009*spd)+n.ph)*.18;
    });
  },
  draw(ctx,s,t,W,H,p,br,showLbl) {
    s.clouds.forEach(c=>glow(ctx,c.x,c.y,c.r,brightRgb(c.rgb,br),c.curAl||c.al));
    s.nodes.forEach(n=>{
      const rgb=brightRgb(n.rgb,br);
      glow(ctx,n.x,n.y,20,rgb,n.op*.6);
      ctx.save();ctx.globalAlpha=n.op*.9;ctx.fillStyle=rgba(...rgb);
      ctx.beginPath();ctx.arc(n.x,n.y,2.2,0,Math.PI*2);ctx.fill();
      if(showLbl) lbl(ctx,n.mol.sym,n.x,n.y-5,rgb,n.op*.65,9);
      ctx.restore();
    });
  },
  tip(s,mx,my) {
    let best=null,bD=28;
    s.nodes.forEach(n=>{const d=Math.sqrt(d2(n.x,n.y,mx,my));if(d<bD){bD=d;best=n;}});
    return best?best.mol:null;
  }
};

// ════════════════════════════════════════════════════════════
// STYLE 4 — Spirale Dorée (Fibonacci)
// ════════════════════════════════════════════════════════════
const Spirale = {
  B: Math.log((1+Math.sqrt(5))/2)/(Math.PI/2),
  init(W,H,mols) {
    const sc=Math.min(W,H)/115;
    const nodes=mols.map((m,i)=>({
      mol:m,rgb:[...m.rgb],th:i*(Math.PI*.38),
      spd:rnd(.00028,.00058),ph:rnd(0,Math.PI*2),op:.5,
    }));
    while(nodes.length<40){const m=pick(mols);nodes.push({mol:m,rgb:[...m.rgb],th:rnd(0,Math.PI*6),spd:rnd(.00022,.0005),ph:rnd(0,Math.PI*2),op:.5});}
    return{nodes,sc,rot:0,cx:W/2,cy:H/2};
  },
  _pt(s,th) {
    const r=s.sc*Math.exp(this.B*th);
    const a=th+s.rot;
    return{x:s.cx+r*Math.cos(a),y:s.cy+r*Math.sin(a),r};
  },
  update(s,t,mx,my,W,H,spd) {
    s.rot=t*(.00025*spd);
    s.nodes.forEach(n=>{
      n.th+=n.spd*spd;if(n.th>Math.PI*9)n.th=.5;
      n.op=.32+Math.sin(t*(.001*spd)+n.ph)*.28;
    });
  },
  draw(ctx,s,t,W,H,p,br,showLbl) {
    ctx.save();ctx.strokeStyle=rgba(...brightRgb(p.a,br),.09);ctx.lineWidth=.8;ctx.beginPath();
    let first=true;
    for(let i=0;i<=1000;i++){
      const th=i/1000*Math.PI*9,pt=this._pt(s,th);
      if(pt.x>-50&&pt.x<W+50&&pt.y>-50&&pt.y<H+50){
        first?ctx.moveTo(pt.x,pt.y):ctx.lineTo(pt.x,pt.y);first=false;
      }
    }
    ctx.stroke();ctx.restore();
    s.nodes.forEach(n=>{
      const pt=this._pt(s,n.th);
      if(pt.x<-20||pt.x>W+20||pt.y<-20||pt.y>H+20)return;
      const nr=clmp(1.8+pt.r/s.sc*.8,1.5,5.5);
      const rgb=brightRgb(n.rgb,br);
      glow(ctx,pt.x,pt.y,nr*5.5,rgb,n.op*.55);
      ctx.save();ctx.globalAlpha=Math.min(n.op+.12,1);ctx.fillStyle=rgba(...rgb);
      ctx.beginPath();ctx.arc(pt.x,pt.y,nr,0,Math.PI*2);ctx.fill();
      if(showLbl&&nr>2.5) lbl(ctx,n.mol.sym,pt.x,pt.y-nr-2,rgb,n.op*.75,Math.round(nr*2.8));
      ctx.restore();
    });
  },
  tip(s,mx,my) {
    let best=null,bD=28;
    s.nodes.forEach(n=>{
      const pt=this._pt(s,n.th);
      const dd=Math.sqrt(d2(pt.x,pt.y,mx,my));if(dd<bD){bD=dd;best=n;}
    });
    return best?best.mol:null;
  }
};

// ════════════════════════════════════════════════════════════
// STYLE 5 — Aurore Olfactive (rubans sinusoïdaux)
// ════════════════════════════════════════════════════════════
const Aurore = {
  init(W,H,mols) {
    const ribs=[
      {y:.27,amp:60,fr:.0054,ph:0,   ca:[0,115,119], cb:[64,193,187]},
      {y:.48,amp:44,fr:.0074,ph:1.4, ca:[200,149,110],cb:[232,190,130]},
      {y:.68,amp:54,fr:.0064,ph:2.7, ca:[107,74,158], cb:[155,125,212]},
      {y:.36,amp:30,fr:.0094,ph:4.1, ca:[64,193,187], cb:[200,149,110]},
      {y:.58,amp:36,fr:.0078,ph:5.5, ca:[184,150,10], cb:[232,200,70]},
    ];
    const nodes=mols.map((m,i)=>{
      const rib=ribs[i%ribs.length];
      return{mol:m,rgb:[...m.rgb],rib,t:rnd(0,1),spd:rnd(.00014,.00042),ph:rnd(0,Math.PI*2),op:.5};
    });
    while(nodes.length<52){const m=pick(mols),rib=pick(ribs);nodes.push({mol:m,rgb:[...m.rgb],rib,t:rnd(0,1),spd:rnd(.0001,.00032),ph:rnd(0,Math.PI*2),op:.5});}
    return{ribs,nodes};
  },
  _npt(n,W,H,t,spd) {
    const x=n.t*W;
    const y=n.rib.y*H+n.rib.amp*Math.sin(n.rib.fr*x+t*(spd*.0006)+n.rib.ph);
    return{x,y};
  },
  update(s,t,mx,my,W,H,spd) {
    s.nodes.forEach(n=>{n.t+=n.spd*spd;if(n.t>1)n.t=0;n.op=.32+Math.sin(t*(.0009*spd)+n.ph)*.28;});
  },
  draw(ctx,s,t,W,H,p,br,showLbl,spd) {
    s.ribs.forEach(r=>{
      const bY=r.y*H;
      [90,45,20].forEach((width,pass)=>{
        const al=[.025,.042,.018][pass];
        ctx.save();ctx.beginPath();
        for(let xi=0;xi<=W;xi+=4){
          const y=bY+r.amp*Math.sin(r.fr*xi+t*(spd*.0006)+r.ph);
          xi===0?ctx.moveTo(xi,y):ctx.lineTo(xi,y);
        }
        const gr=ctx.createLinearGradient(0,0,W,0);
        gr.addColorStop(0,  rgba(...brightRgb(r.ca,br),0));
        gr.addColorStop(.15,rgba(...brightRgb(r.ca,br),al));
        gr.addColorStop(.5, rgba(...brightRgb(r.cb,br),al*1.6));
        gr.addColorStop(.85,rgba(...brightRgb(r.ca,br),al));
        gr.addColorStop(1,  rgba(...brightRgb(r.ca,br),0));
        ctx.strokeStyle=gr;ctx.lineWidth=width;ctx.stroke();ctx.restore();
      });
      ctx.save();ctx.beginPath();
      for(let xi=0;xi<=W;xi+=3){
        const y=bY+r.amp*Math.sin(r.fr*xi+t*(spd*.0006)+r.ph);xi===0?ctx.moveTo(xi,y):ctx.lineTo(xi,y);
      }
      ctx.strokeStyle=rgba(...brightRgb(r.ca,br),.18);ctx.lineWidth=1;ctx.stroke();ctx.restore();
    });
    s.nodes.forEach(n=>{
      const pt=this._npt(n,W,H,t,spd);
      const rgb=brightRgb(n.rgb,br);
      glow(ctx,pt.x,pt.y,16,rgb,n.op*.45);
      ctx.save();ctx.globalAlpha=n.op;ctx.fillStyle=rgba(...rgb);
      ctx.beginPath();ctx.arc(pt.x,pt.y,2.8,0,Math.PI*2);ctx.fill();
      if(showLbl) lbl(ctx,n.mol.sym,pt.x,pt.y-6,rgb,n.op*.72,10);
      ctx.restore();
    });
  },
  tip(s,mx,my,t,W,H,spd) {
    let best=null,bD=28;
    s.nodes.forEach(n=>{const pt=this._npt(n,W,H,t,spd);const dd=Math.sqrt(d2(pt.x,pt.y,mx,my));if(dd<bD){bD=dd;best=n;}});
    return best?best.mol:null;
  }
};

const STYLES = {constellation:Constellation,floraison:Floraison,brume:Brume,spirale:Spirale,aurore:Aurore};

// ── Gestionnaire d'instances ─────────────────────────────
function createInst(anchor) {
  const styleName  = anchor.dataset.style    || 'constellation';
  const palName    = anchor.dataset.colors   || 'teal';
  const opacity    = parseFloat(anchor.dataset.opacity   || '0.75');
  const brightness = parseFloat(anchor.dataset.brightness|| '1');
  const speed      = parseFloat(anchor.dataset.speed     || '4');
  const blend      = anchor.dataset.blend    || 'screen';
  const interact   = anchor.dataset.interact !== 'false';
  const showLbl    = anchor.dataset.showLabels !== 'false';
  const showTip    = anchor.dataset.showTip   !== 'false';
  const ingrStr    = anchor.dataset.ingredients || '';
  const datasetKey = anchor.dataset.dataset    || 'matieres';
  const textMat    = anchor.dataset.textMat    || '';
  const textMol    = anchor.dataset.textMol    || '';
  const textNat    = anchor.dataset.textNat    || '';

  const pal    = PAL[palName] || PAL.teal;
  const style  = STYLES[styleName] || STYLES.constellation;
  const mols   = buildMolSet(datasetKey, ingrStr, {mat:textMat, mol:textMol, nat:textNat});

  // Section parente
  const sec = anchor.closest('.shopify-section, section, [data-section-id]') || anchor.parentElement;
  const cp  = getComputedStyle(sec).position;
  if(!['relative','absolute','fixed','sticky'].includes(cp)) sec.style.position='relative';
  sec.style.overflow='hidden';

  // Canvas principal
  const cv = document.createElement('canvas');
  cv.setAttribute('aria-hidden','true');
  cv.style.cssText=`position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:3;mix-blend-mode:${blend};`;
  sec.appendChild(cv);

  // Tooltip
  const tip = showTip ? document.createElement('div') : null;
  if(tip){ tip.className='fh-mol-tip'; document.body.appendChild(tip); }

  let W2,H2,state,lastT=0,mx=-9999,my=-9999,raf2;
  // Transition cross-fade
  let prevStyle=null,prevState=null,transAlpha=0,inTransition=false;

  function resize2() {
    W2=cv.width=sec.offsetWidth||window.innerWidth;
    H2=cv.height=sec.offsetHeight||window.innerHeight;
    state=style.init(W2,H2,mols);
  }

  if(interact) {
    sec.addEventListener('mousemove',e=>{
      const r=sec.getBoundingClientRect();
      mx=e.clientX-r.left; my=e.clientY-r.top;
      if(!showTip||!tip) return;
      const mol=style.tip?style.tip(state,mx,my,lastT,W2,H2,speed):null;
      if(mol){
        let html=`<b>${esc(mol.name)}</b><span>${esc(mol.src)}</span><i>${esc(mol.fam)}</i>`;
        if(mol.sci) html+=`<span class="fh-sci">${esc(mol.sci)}</span>`;
        if(mol.parfum) html+=`<em>${esc(mol.parfum)}</em>`;
        if(mol.note) html+=`<u>${esc(mol.note)}</u>`;
        tip.innerHTML=html;
        tip.style.left=(e.clientX+20)+'px';
        tip.style.top=(e.clientY-14)+'px';
        tip.classList.add('fh-mol-tip--on');
      } else { tip.classList.remove('fh-mol-tip--on'); }
    });
    sec.addEventListener('mouseleave',()=>{mx=my=-9999;if(tip)tip.classList.remove('fh-mol-tip--on');});
  }

  function loop(t) {
    raf2=requestAnimationFrame(loop);
    lastT=t;
    const ctx=cv.getContext('2d');
    ctx.clearRect(0,0,W2,H2);
    ctx.save();
    ctx.globalAlpha=opacity;

    // Transition cross-fade entre 2 styles
    if(inTransition && prevStyle && prevState) {
      transAlpha=clmp(transAlpha+.018,0,1);
      // Dessine l'ancien style en s'effaçant
      ctx.globalAlpha=opacity*(1-transAlpha);
      if(prevStyle.update) prevStyle.update(prevState,t,mx,my,W2,H2,speed);
      if(prevStyle.draw)   prevStyle.draw(ctx,prevState,t,W2,H2,pal,brightness,showLbl,speed);
      // Dessine le nouveau style qui apparait
      ctx.globalAlpha=opacity*transAlpha;
      if(style.update) style.update(state,t,mx,my,W2,H2,speed);
      if(style.draw)   style.draw(ctx,state,t,W2,H2,pal,brightness,showLbl,speed);
      if(transAlpha>=1){ inTransition=false; prevStyle=null; prevState=null; }
    } else {
      if(style.update) style.update(state,t,mx,my,W2,H2,speed);
      if(style.draw)   style.draw(ctx,state,t,W2,H2,pal,brightness,showLbl,speed);
    }

    ctx.restore();
  }

  resize2();
  window.addEventListener('resize',resize2);
  requestAnimationFrame(loop);

  return {
    destroy(){ cancelAnimationFrame(raf2);cv.remove();if(tip)tip.remove();window.removeEventListener('resize',resize2); }
  };
}

// ── API publique ──────────────────────────────────────────
const FHMol = {
  init(id) {
    const el=document.getElementById(id);
    if(!el||el._fhDone)return;
    el._fhDone=true;
    createInst(el);
  }
};
W.FHMol=FHMol;

// Expose pour la démo
W._FHS={ Constellation,Floraison,Brume,Spirale,Aurore,PAL,MOLS,MOLECULES,NATURELLES,STYLES,buildMolSet,parseMolLines,esc,glow,lbl,brightRgb,rgba,rnd,clmp,d2,pick };

const q=W.__fh_q;
if(Array.isArray(q))q.forEach(id=>FHMol.init(id));
W.__fh_q={push:id=>FHMol.init(id)};

}(window));